import React, { useState, useEffect, useRef, useContext } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import './confirmationModal.css';

const ConfirmationModalFaktura = ({
  visible,
  onHide,
  onConfirmContinue,
  onConfirmExit,
  onConfirmRemove,
  idItem,
  children
}) => {

  const header = ( 
    <div>
      <Button
        label={idItem ? "Sačuvaj i dodaj" : "Unesi i dodaj"}
        icon="pi pi-plus"
        onClick={onConfirmContinue}
        severity="success"
        style={{marginRight:'2%'}}
      />
      <Button
        label={idItem ? "Sačuvaj i izađi" : "Unesi i izađi"}
        icon="pi pi-sign-out"
        onClick={onConfirmExit} 
        severity="warning" 
      />   
      {idItem &&  <Button
        label="Storno"
        style={{marginLeft:'2%'}}
        icon="pi pi-sign-out"
        onClick={onConfirmRemove} 
        severity="danger" 
      />}   

    </div>
  );

  const formatDateSR = (isoString) => {
  if (!isoString) return '';

  const d = new Date(isoString);

  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();

  return `${day}.${month}.${year}`;
};

const formatNumber = (value) => {
  if (value === null || value === undefined) return '-';
  return Number(value).toLocaleString('sr-RS', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

  return (
    <Dialog
      header={header}
      visible={visible}
      style={{ width: '50%' }}
      onHide={onHide}
      modal
      className="confirmation-modal"
    >
            {children}
    </Dialog>
  );
};

export default ConfirmationModalFaktura;